export default "__VITE_ASSET__DwPfynzz__"